/* eslint-disable @typescript-eslint/no-explicit-any */
import i18n from 'i18next';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// 로컬 리소스 동적 로딩을 위한 매핑
const localResourceMap: Record<string, Record<string, () => Promise<any>>> = {
  ko: { worker_web: () => import('~/lib/locales/ko.json') },
  en: { worker_web: () => import('~/lib/locales/en.json') },
  vi: { worker_web: () => import('~/lib/locales/vi.json') },
  pl: { worker_web: () => import('~/lib/locales/pl.json') },
  de: { worker_web: () => import('~/lib/locales/de.json') },
  id: { worker_web: () => import('~/lib/locales/id.json') },
  ja: { worker_web: () => import('~/lib/locales/ja.json') },
  th: { worker_web: () => import('~/lib/locales/th.json') },
  es: { worker_web: () => import('~/lib/locales/es.json') },
  zh_cn: { worker_web: () => import('~/lib/locales/zh_cn.json') },
  zh_tw: { worker_web: () => import('~/lib/locales/zh_tw.json') },
  km: { worker_web: () => import('~/lib/locales/km.json') },
  ne: { worker_web: () => import('~/lib/locales/ne.json') },
  my: { worker_web: () => import('~/lib/locales/my.json') },
  mn: { worker_web: () => import('~/lib/locales/mn.json') },
};

// 커스텀 백엔드: 로컬 리소스는 동적 import, 원격 리소스는 HTTP 로드
class HybridBackend {
  static type = 'backend' as const;
  type = 'backend' as const;

  private httpBackend = new Backend();

  init(services: any, backendOptions: HttpBackendOptions) {
    this.httpBackend.init(services, backendOptions);
  }

  async read(language: string, namespace: string, callback: (err: any, data?: any) => void) {
    const localResource = localResourceMap[language]?.[namespace];

    if (localResource) {
      try {
        const resource = await localResource();
        callback(null, resource.default || resource);
      } catch (error) {
        console.warn(`Failed to load local resource ${language}/${namespace}:`, error);
        // 로컬 로딩 실패 시 HTTP 백엔드로 fallback
        this.httpBackend.read(language, namespace, callback);
      }
    } else {
      // 로컬 리소스가 없으면 HTTP 백엔드 사용 (global, error_code, error_page)
      this.httpBackend.read(language, namespace, callback);
    }
  }
}

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(new HybridBackend())
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    backend: {
      loadPath: 'https://caas-locales.s3.ap-northeast-2.amazonaws.com/{{lng}}/{{ns}}.json',
    },
    ns: ['global', 'error_code', 'error_page', 'worker_web'],
    lng: 'ko',
    fallbackLng: ['en', 'ko'],
    interpolation: { escapeValue: false },
    react: {
      useSuspense: true,
    },
    load: 'currentOnly',
    supportedLngs: [
      'ko',
      'en',
      'vi',
      'pl',
      'de',
      'id',
      'ja',
      'th',
      'es',
      'zh_cn',
      'zh_tw',
      'km',
      'ne',
      'my',
      'mn',
    ],
  });

export default i18n;
